import React from 'react';
import { Group } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';

import type { ContestInviteCardActionButtonsProps } from './types';

function ContestInviteCardActionButtons({
  invite,
  onAccept,
  onDecline,
  isLoading,
}: ContestInviteCardActionButtonsProps) {
  const { t } = useTranslation('contest');
  return (
    <Group grow /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8}>
      <Button
        variant="tertiary-fill"
        size="small"
        loading={isLoading}
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation();
          onDecline?.(invite.id, e);
        }}
      >
        <Text variant="label-small">{t('common.contestInviteCard.actionButtons.decline')}</Text>
      </Button>
      <Button
        variant="primary-fill"
        size="small"
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation();
          onAccept?.(invite.id, e);
        }}
      >
        <Text variant="label-small">{t('common.contestInviteCard.actionButtons.viewContest')}</Text>
      </Button>
    </Group>
  );
}

export default ContestInviteCardActionButtons;
